"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../assets/icons");

var _Icon = require("./Icon.style");

var _utils = require("../lib/utils");

var _styledComponents = require("styled-components");

var _excluded = ["size", "iconName", "className", "onClick", "hoverColor", "color", "shade"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var sizeMap = {
  s: 16,
  m: 24,
  l: 32,
  xl: 48
};

var Icon = function Icon(_ref) {
  var size = _ref.size,
      iconName = _ref.iconName,
      className = _ref.className,
      onClick = _ref.onClick,
      hoverColor = _ref.hoverColor,
      color = _ref.color,
      shade = _ref.shade,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var theme = (0, _styledComponents.useTheme)();
  var spaceProps = (0, _utils.getProps)(props, function (key) {
    return _utils.spaceObj.includes(key);
  });
  var restProps = (0, _utils.getProps)(props, function (key) {
    return !_utils.spaceObj.includes(key);
  });
  var IconComponent = _icons.Icons[iconName];
  var iconSize = size;
  if (typeof size === 'string' && Object.keys(sizeMap).includes(size)) iconSize = sizeMap[size];
  return IconComponent ? /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: ""
  }, /*#__PURE__*/_react["default"].createElement(_Icon.StyledIcon, (0, _extends2["default"])({
    className: className,
    onClick: onClick,
    hoverColor: hoverColor
  }, spaceProps), /*#__PURE__*/_react["default"].createElement(IconComponent, (0, _extends2["default"])({
    size: iconSize
  }, restProps, {
    fill: (0, _utils.getPalette)(color, shade)({
      theme: theme
    }) || props.fill
  })))) : null;
};

Icon.defaultProps = {
  size: 's',
  fill: '#242424'
};
Icon.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['s', 'm', 'l', 'xl'])]),
  iconName: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,

  /**
   a callback func, which takes `event` argument
   */
  onClick: _propTypes["default"].func,
  fill: _propTypes["default"].string,
  hoverColor: _propTypes["default"].string,

  /**
   color can be from palette eg: primary, secondary ... or color code #ff0000
   */
  color: _propTypes["default"].string,

  /**
   eg: c01, c02, c03, c04
   */
  shade: _propTypes["default"].string
};
var _default = Icon;
exports["default"] = _default;